export const MOBILE = 425;
export const TABLET = 768;
export const SMALLDESKTOP = 1024;
export const IPHONEX =
  "@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3)";
